module.exports = __webpack_public_path__ + "img/public/SiteIcons/complete.svg?b3cfba59";